import React from "react";
import { useInView } from "react-intersection-observer";
import { FaBiking, FaMusic, FaBookOpen } from "react-icons/fa";
import {GiCampCookingPot} from "react-icons/gi"


const Hobbies = () => {
  // Intersection observer
  const {ref: hobbiesSectionTitleRef, inView: hobbiesSectionTitleIsVisible } = useInView({ 
    triggerOnce: true
  });

  const {ref: hobbyOneRef, inView: hobbyOneIsVisible } = useInView({ 
    triggerOnce: true
  });
  const {ref: hobbyTwoRef, inView: hobbyTwoIsVisible } = useInView({ 
    triggerOnce: true
  });
  const {ref: hobbyThreeRef, inView: hobbyThreeIsVisible } = useInView({ 
    triggerOnce: true
  });
  const {ref: hobbyFourRef, inView: hobbyFourIsVisible } = useInView({ 
    triggerOnce: true
  });

  return (
    <section className="hobbies-section">
      <div className="hobbies-title-div">
        <h1 ref={hobbiesSectionTitleRef} className={`${hobbiesSectionTitleIsVisible ? "hobbies-title show-title" : "hobbies-title"}`}>Hobbies</h1>
        <div className="title-underline"></div>
      </div>
      
      <div className="hobbies">
        <span ref={hobbyOneRef} className={`${hobbyOneIsVisible ? "hobby-one show-hobby-one" : "hobby-one"}`}><GiCampCookingPot className="hobbies-icon"/>Cooking</span>
        <span ref={hobbyTwoRef} className={`${hobbyTwoIsVisible ? "hobby-two show-hobby-two" : "hobby-two"}`}><FaBiking className="hobbies-icon"/>Sports </span>
        <span ref={hobbyThreeRef} className={`${hobbyThreeIsVisible ? "hobby-three show-hobby-three" : "hobby-three"}`}><FaMusic className="hobbies-icon"/>Music</span>
        <span ref={hobbyFourRef} className={`${hobbyFourIsVisible ? "hobby-four show-hobby-four" : "hobby-four"}`}><FaBookOpen className="hobbies-icon"/>Reading</span>
      </div>
    </section>
  );
}

export default Hobbies;
